import { __decorate, __param, __metadata } from 'tslib';
import { ɵɵdefineInjectable, ɵɵinject, Injectable, Inject, EventEmitter, Input, Output, Component, Pipe, NgModule, LOCALE_ID, Optional, SkipSelf } from '@angular/core';
import { APP_PARAMETER } from '@wlp/ui-bs-parameter';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { UiBsTranslateModule } from '@wlp/ui-bs-translate';

let UiCWalletTransactionsService = class UiCWalletTransactionsService {
    constructor(param) {
        this.config = param;
    }
    getConfig() {
        return this.config;
    }
};
UiCWalletTransactionsService.ngInjectableDef = ɵɵdefineInjectable({ factory: function UiCWalletTransactionsService_Factory() { return new UiCWalletTransactionsService(ɵɵinject(APP_PARAMETER)); }, token: UiCWalletTransactionsService, providedIn: "root" });
UiCWalletTransactionsService = __decorate([
    Injectable({
        providedIn: 'root'
    }),
    __param(0, Inject(APP_PARAMETER)),
    __metadata("design:paramtypes", [Object])
], UiCWalletTransactionsService);

let UiCWalletTransactionsComponent = class UiCWalletTransactionsComponent {
    constructor(service) {
        this.service = service;
        this.transactions = [];
        this.sltPeriod = new EventEmitter();
        this.dateList = [];
        // recebe o tipo de device usado (pelo service do componente)
        try {
            this.device = this.service.getConfig().device.toLowerCase();
        }
        catch (err) {
            this.device = this.service.getConfig().device;
        }
        this.loadDataList();
    }
    ngOnInit() { }
    getTransactionIcon(name) {
        return this.showIcon(`icons/${name}`);
    }
    showIcon(icon, extension) {
        let iconUrl = `${this.pathIcon}/${icon}.svg`;
        if (extension) {
            iconUrl = iconUrl.replace(/\.svg$/, `.${extension}`);
        }
        return iconUrl;
    }
    showStatus(status) {
        let str = '';
        switch (status) {
            case 'PENDING':
                str = 'Pendente';
                break;
            case 'AUTHORIZED':
                str = 'Aprovado';
                break;
            case 'NOT_AUTHORIZED':
                str = 'Não Aprovado';
                break;
            case 'NO_AUTHORIZED':
                str = 'Não Aprovado';
                break;
            default:
                str = 'Pendente';
                break;
        }
        return str;
    }
    getStatusColor(name) {
        switch (name) {
            case 'PENDING': {
                return '';
            }
            case 'WAITING_PROCESSING': {
                return '';
            }
            case 'PROCESSING': {
                return '';
            }
            case 'AUTHORIZED': {
                return '';
            }
            case 'NOT_AUTHORIZED': {
                return 'dangerColorValue';
            }
            case 'SCHEDULED': {
                return '';
            }
            default: {
                return '';
            }
        }
    }
    getStatus(name) {
        switch (name) {
            case 'PENDING': {
                return 'PENDENTE';
            }
            case 'WAITING_PROCESSING': {
                return 'AGUARDANDO PROCESSAMENTO';
            }
            case 'PROCESSING': {
                return 'EM PROCESSAMENTO';
            }
            case 'AUTHORIZED': {
                return 'APROVADO';
            }
            case 'NOT_AUTHORIZED': {
                return 'NÃO APROVADO';
            }
            case 'SCHEDULED': {
                return 'AGENDADA';
            }
            default: {
                return '';
            }
        }
    }
    loadDataList() {
        let cont = 12;
        let dateProg;
        let year = new Date().getFullYear();
        let regr = (new Date().getMonth()) + 1;
        for (12; cont > 0; cont--, regr--) {
            if (regr == 0) {
                regr = 12;
                year = year - 1;
            }
            dateProg = new Date((year + '-' + regr + '-' + '02'));
            this.dateList.push({
                name: this.datesToList(dateProg),
                period: this.formatDate(dateProg)
            });
        }
    }
    datesToList(date) {
        let year = date.getFullYear();
        let month = date.getMonth();
        switch (month) {
            case 0:
                month = "Janeiro";
                break;
            case 1:
                month = "Fevereiro";
                break;
            case 2:
                month = "Março";
                break;
            case 3:
                month = "Abril";
                break;
            case 4:
                month = "Maio";
                break;
            case 5:
                month = "Junho";
                break;
            case 6:
                month = "Julho";
                break;
            case 7:
                month = "Agosto";
                break;
            case 8:
                month = "Setembro";
                break;
            case 9:
                month = "Outubro";
                break;
            case 10:
                month = "Novembro";
                break;
            case 11:
                month = "Dezembro";
                break;
        }
        if (month.toString().length == 1) {
            month = "0" + month;
        }
        return month + '/' + year;
    }
    formatDate(date) {
        let year = date.getFullYear();
        let month = (date.getMonth() + 1);
        let day = date.getDate();
        if (day.toString().length == 1) {
            day = "0" + day;
        }
        if (month.toString().length == 1) {
            month = "0" + month;
        }
        return year + '-' + month + '-' + day;
    }
    selectedPeriod(evt) {
        this.sltPeriod.emit(evt);
    }
};
__decorate([
    Input(),
    __metadata("design:type", Object)
], UiCWalletTransactionsComponent.prototype, "pathIcon", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], UiCWalletTransactionsComponent.prototype, "simple", void 0);
__decorate([
    Input(),
    __metadata("design:type", Array)
], UiCWalletTransactionsComponent.prototype, "transactions", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCWalletTransactionsComponent.prototype, "platform", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UiCWalletTransactionsComponent.prototype, "sltPeriod", void 0);
UiCWalletTransactionsComponent = __decorate([
    Component({
        selector: 'ui-c-wallet-transactions',
        template: "<div [ngClass]=\"(platform === 'casa-feliz') ? 'wallet-transactions-component-casafeliz mt-3' : 'wallet-transactions-component m-3'\">\n  <ion-row class=\"col-12 d-flex justify-content-between align-items-center mt-3 p-0 row-title-transactions\">\n    <ion-col class=\"col-7 px-3 col-title-transactions\">\n      <ion-text class=\"font-family-bold text-page-primary\">\n        {{'WALLET.TRANSACTIONS.TRANSACTIONS_TITLE' | wlpTranslate}}\n      </ion-text>\n    </ion-col>\n    <!-- dsativado por enquanto!!! -->\n    <!-- <ion-col class=\"col-6 text-right\">\n    <ion-select id=\"month-filter\" class=\"px-1 py-0\" placeholder=\"{{'NSC.WALLET.PLACEHOLDER.PERIOD' | wlpTranslate}}\"\n      cancelText=\"{{'NSC.WALLET.PLACEHOLDER.CANCEL' | wlpTranslate}}\">\n      <ion-select-option value=\"Janeiro/2020\"> Janeiro/2020 </ion-select-option>\n      <ion-select-option value=\"Fevereiro/2020\"> Fevereiro/2020 </ion-select-option>\n      <ion-select-option value=\"Mar\u00E7o/2020\"> Mar\u00E7o/2020 </ion-select-option>\n      <ion-select-option value=\"Abril/2020\"> Abril/2020 </ion-select-option>\n      <ion-select-option value=\"Maio/2020\"> Maio/2020 </ion-select-option>\n      <ion-select-option value=\"Junho/2020\"> Junho/2020 </ion-select-option>\n      <ion-select-option value=\"Julho/2020\"> Julho/2020 </ion-select-option>\n      <ion-select-option value=\"Agosto/2020\"> Agosto/2020 </ion-select-option>\n      <ion-select-option value=\"Setembro/2020\"> Setembro/2020 </ion-select-option>\n      <ion-select-option value=\"Outubro/2020\"> Outubro/2020 </ion-select-option>\n      <ion-select-option value=\"Novembro/2020\"> Novembro/2020 </ion-select-option>\n      <ion-select-option value=\"Dezembro/2020\"> Dezembro/2020 </ion-select-option>\n    </ion-select>\n  </ion-col> -->\n    <ion-col class=\"col-5 text-right col-title-transactions pl-0 pr-3\" *ngIf=\"platform === 'casa-feliz'\">\n      <ion-select placeholder=\"Selecione o per\u00EDodo\" cancelText=\"Cancelar\"\n        (ionChange)=\"selectedPeriod($event.target.value)\">\n        <ion-select-option value=\"All\"> Todos </ion-select-option>\n        <ion-select-option [value]=\"item.period\" *ngFor=\"let item of dateList\">{{item.name}}</ion-select-option>\n      </ion-select>\n    </ion-col>\n  </ion-row>\n\n  <ion-grid id=\"transaction-container\" [ngClass]=\"(platform === 'casa-feliz') ? 'col-12' : 'mt-1 col-10 px-0'\">\n    <ng-container *ngIf=\"transactions.length > 0\">\n      <ion-row class=\"my-3 d-block px-2\" *ngFor=\"let transaction of transactions\">\n        <ion-col class=\"d-flex justify-content-between align-items-center\">\n          <div *ngIf=\"!simple\" class=\"icon-transaction-container col-2 p-2 mr-2\">\n            <ion-img class=\"w-100 mx-auto\" [src]=\"getTransactionIcon('lojas')\"></ion-img>\n            <!-- [src]=\"getTransactionIcon(transaction.type)\" -->\n          </div>\n          <div class=\"col-6 d-flex flex-column justify-content-start align-items-start px-0\">\n            <ion-text class=\"d-block text-transform-capitalize font-family-bold transaction-store px-0\">\n              {{ transaction.description }}\n            </ion-text>\n            <ion-text\n              [ngClass]=\"'d-block text-transform-capitalize font-size-10 font-family-bold transaction-store px-0 ' + getStatusColor(transaction.status)\">\n              {{ getStatus(transaction.status) }}\n            </ion-text>\n            <ng-container *ngIf=\"device === 'web'\">\n              <ion-text class=\"text-left px-0\">\n                <small class=\"transaction-date\"> {{ transaction.dateRegister | date: 'dd/MM/yyyy HH:mm' }} </small>\n              </ion-text>\n            </ng-container>\n          </div>\n          <div class=\"col-4 d-flex flex-column justify-content-between align-items-end px-0\">\n            <ion-text [innerHtml]=\"transaction.amount | currency:'BRL' | walletCurrency\"\n              [ngClass]=\"transaction.status === 'NOT_AUTHORIZED' ? 'd-block text-transform-capitalize text-right transaction-price px-0 amount-text-line' : ' d-block text-transform-capitalize text-right transaction-price px-0'\">\n            </ion-text>\n            <!-- estrutura de cashback para web -->\n            <ng-container *ngIf=\"device === 'web'\">\n              <ion-text\n                class=\"cashback-show-value-container col-4 text-left d-flex justify-content-between align-items-center px-0 mt-2\">\n                <!-- caso houver cashback -->\n                <!-- <ng-container *ngIf=\"transaction.cashback !== null && !simple \">\n                <div class=\"cashback-show-value d-flex justify-content-between align-items-center w-100 pl-3\">\n                  <small> {{ transaction.cashback | currency:'BRL' }} </small>\n                  <div class=\"cashback-container\">\n                    <ion-img [src]=\"showIcon('cashbackBranco')\"></ion-img>\n                  </div>\n                </div>\n              </ng-container> -->\n                <!-- caso nao houver cashback -->\n                <ng-container *ngIf=\"transaction.cashback === null && !simple\">\n                  <small class=\"text-right w-100 d-block no-cashback\"> {{'WALLET.NO_CASHBACK' | wlpTranslate}}\n                  </small>\n                </ng-container>\n              </ion-text>\n            </ng-container>\n            <!-- estrutura de cashback para web (fim) -->\n          </div>\n        </ion-col>\n\n        <!-- estrutura de cashback para app -->\n        <ng-container *ngIf=\"device === 'app'\">\n          <ion-col class=\"py-0 font-family-bold d-flex font-size-12 justify-content-between align-items-center\">\n\n            <ion-text class=\"col-8 text-left px-0\" >\n              <small class=\"transaction-date\"> {{ transaction.dateRegister | date: 'dd/MM/yyyy HH:mm' }} </small>\n            </ion-text>\n            <ion-text class=\"cashback-show-value-container col-4 text-left d-flex justify-content-between align-items-center px-0\">\n\n              <!-- caso houver cashback -->\n              <!-- <ng-container *ngIf=\"transaction.cashback !== null && !simple \">\n              <div class=\"cashback-show-value d-flex justify-content-between align-items-center w-100 pl-3\">\n                <small> {{ transaction.cashback | currency:'BRL' }} </small>\n                <div class=\"cashback-container\">\n                  <ion-img [src]=\"showIcon('cashbackBranco')\"></ion-img>\n                </div>\n              </div>\n            </ng-container> -->\n\n              <!-- caso nao houver cashback -->\n              <ng-container *ngIf=\"!simple\">\n                <small class=\"text-right w-100 d-block no-cashback\"> {{ showStatus(transaction.status) }} </small>\n              </ng-container>\n              <ng-container *ngIf=\"transaction.cashback === null && !simple\">\n                <small class=\"text-right w-100 d-block no-cashback\"> Sem Cashback </small>\n              </ng-container>\n\n            </ion-text>\n\n          </ion-col>\n        </ng-container>\n        <!-- estrutura de cashback para app (fim) -->\n      </ion-row>\n    </ng-container>\n\n    <ng-container class=\"no-transactions\" *ngIf=\"transactions?.length === 0\">\n      <ion-row class=\"my-3 d-block px-2\">\n        <ion-text class=\"text-center w-100 d-block text-page-primary font-family-bold\"> N\u00E3o existem transa\u00E7\u00F5es\n        </ion-text>\n      </ion-row>\n    </ng-container>\n  </ion-grid>\n</div>\n",
        styles: [""]
    }),
    __metadata("design:paramtypes", [UiCWalletTransactionsService])
], UiCWalletTransactionsComponent);

let WalletCurrencyPipe = class WalletCurrencyPipe {
    transform(value) {
        if (!value) {
            return;
        }
        const costPosition = value.search(/\d/); // posicao do valor dentro da string
        const cost = value.substring(costPosition); // Valor
        const currency = value.substring(0, costPosition); // Simbolo monetario
        return `<span class="wallet-currency">${currency}</span>${cost}`;
    }
};
WalletCurrencyPipe = __decorate([
    Pipe({ name: 'walletCurrency' })
], WalletCurrencyPipe);

var UiCWalletTransactionsModule_1;
let UiCWalletTransactionsModule = UiCWalletTransactionsModule_1 = class UiCWalletTransactionsModule {
    constructor(parentModule) {
        //...
    }
    static forRoot(config) {
        return {
            ngModule: UiCWalletTransactionsModule_1,
            providers: [
                { provide: APP_PARAMETER, useValue: config }
            ]
        };
    }
};
UiCWalletTransactionsModule = UiCWalletTransactionsModule_1 = __decorate([
    NgModule({
        declarations: [
            UiCWalletTransactionsComponent,
            WalletCurrencyPipe
        ],
        imports: [
            CommonModule,
            IonicModule,
            ReactiveFormsModule,
            FormsModule,
            UiBsTranslateModule
        ],
        exports: [UiCWalletTransactionsComponent],
        providers: [
            UiCWalletTransactionsService,
            { provide: LOCALE_ID, useValue: 'pt-BR' }
        ]
    }),
    __param(0, Optional()), __param(0, SkipSelf()),
    __metadata("design:paramtypes", [UiCWalletTransactionsModule])
], UiCWalletTransactionsModule);

export { UiCWalletTransactionsComponent, UiCWalletTransactionsModule, UiCWalletTransactionsService as ɵa, WalletCurrencyPipe as ɵb };
//# sourceMappingURL=wlp-ui-c-wallet-transactions.js.map
